export const DASHBOARD_RANGE_OPTIONS = [
  { value: '7d', labelKey: 'DASHBOARD_FILTER_RANGE_OPTION_7D' },
  { value: '30d', labelKey: 'DASHBOARD_FILTER_RANGE_OPTION_30D' },
  { value: '365d', labelKey: 'DASHBOARD_FILTER_RANGE_OPTION_365D' },
  { value: 'custom', labelKey: 'DASHBOARD_FILTER_RANGE_OPTION_CUSTOM' }
]

export const rangeFilterDefaults = {
  range: '30d',
  from: '',
  to: ''
}

const numberFormatter = new Intl.NumberFormat('tr-TR', {
  maximumFractionDigits: 1
})

export const formatNumber = (value) => {
  if (value === null || value === undefined || Number.isNaN(value)) {
    return '0'
  }
  return numberFormatter.format(value)
}

export const formatCurrency = (value) => {
  if (value === null || value === undefined || Number.isNaN(value)) {
    return '₺0'
  }
  return new Intl.NumberFormat('tr-TR', {
    style: 'currency',
    currency: 'TRY',
    maximumFractionDigits: 0
  }).format(value)
}

export const formatDateTime = (value) => {
  if (!value) return '-'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value
  return new Intl.DateTimeFormat('tr-TR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(date)
}

const statusTranslationKeyMap = {
  draft: 'APPLICATIONS_STATUS_DRAFT',
  submitted: 'APPLICATIONS_STATUS_SUBMITTED',
  under_review: 'APPLICATIONS_STATUS_UNDER_REVIEW',
  accepted: 'APPLICATIONS_STATUS_ACCEPTED',
  rejected: 'APPLICATIONS_STATUS_REJECTED',
  waitlisted: 'APPLICATIONS_STATUS_WAITLISTED',
  cancelled: 'APPLICATIONS_STATUS_CANCELLED'
}

const statusColorMap = {
  draft: '#90a4ae',
  submitted: '#42a5f5',
  under_review: '#ffb300',
  accepted: '#66bb6a',
  rejected: '#ef5350',
  waitlisted: '#ab47bc',
  cancelled: '#757575'
}

export const getStatusColor = (status) => statusColorMap[status] || '#607d8b'
export const getStatusLabelKey = (status) => statusTranslationKeyMap[status] || status

const missingDocumentKeyMap = {
  passport: 'DASHBOARD_DOCUMENT_PASSPORT',
  transcript: 'DASHBOARD_DOCUMENT_TRANSCRIPT',
  diploma: 'DASHBOARD_DOCUMENT_DIPLOMA',
  cv: 'DASHBOARD_DOCUMENT_CV',
  motivationLetter: 'DASHBOARD_DOCUMENT_MOTIVATION_LETTER'
}

export const getMissingDocumentLabelKey = (key) => missingDocumentKeyMap[key] || key

export const getRangeLabelKey = (rangeValue) => {
  const option = DASHBOARD_RANGE_OPTIONS.find((opt) => opt.value === rangeValue)
  return option?.labelKey || rangeValue
}

export const emptyDashboardData = {
  meta: {
    range: rangeFilterDefaults
  },
  kpis: {},
  charts: {
    applicationsByStatus: {},
    applicationsTrend: []
  },
  lists: {},
  alerts: []
}

